// extracted by mini-css-extract-plugin
export default {"shadowed":"Home_shadowed__tgESU","hand":"Home_hand__19HyH","wave":"Home_wave__z2cdB"};